import styled from "styled-components";

export const AlertNotifStyled = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;

  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;

  display: flex;
  align-items: center;
  justify-content: center;

  /* transition: opacity 1.5s; */
  transition: 0.5s;
  visibility: ${({ show }) => (show ? "visible" : "hidden")};
  opacity: ${({ show }) => (show ? 1 : 0)};

  .alert-page__inner {
    background-color: white;
    border-radius: 10px;
    min-width: 250px;
    min-height: 150px;
    max-width: 400px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    flex-direction: column;
    font-size: 1.1em;
    padding: 20px;
    text-align: justify;
  }

  .alert-page__btn {
    flex-grow: 1;
    background-color: #ffbf1d;
    width: 100%;
    padding: 5px;
    font-weight: bold;
    font-size: 1.1em;
  }
`;
